/* stylelint-disable selector-max-compound-selectors */
/* cwc-component-info-bar */
$infobar-animation-duration: var(--cwc-infobar-animation-duration, 0.5s) !default;
$infobar-wrapper-maxwidth: var(--cwc-infobar-wrapper-maxwidth, 1024px) !default;
$infobar-wrapper-padding-vert: 0.5em !default;
$infobar-custom-background-color: var(--cwc-infobar-background-color, #fff) !default;
$infobar-custom-font-color: var(--cwc-infobar-font-color, #333) !default;

:host {
  /**
   * @prop --cwc-infobar-animation-duration - duration of the slide down animation.
   * @prop --cwc-infobar-wrapper-maxwidth - max with of the inner wrapper.
   * @prop --cwc-infobar-background-color - background color used in custom scheme.
   * @prop --cwc-infobar-background-color-blue - background color used in color-scheme="blue"
   * @prop --cwc-infobar-background-color-custom - background color used in color-scheme="custom"
   * @prop --cwc-infobar-background-color-green - background color used in color-scheme="green"
   * @prop --cwc-infobar-background-color-grey - background color used in color-scheme="grey"
   * @prop --cwc-infobar-background-color-red - background color used in color-scheme="red"
   * @prop --cwc-infobar-background-color-violet - background color used in color-scheme="violet"
   * @prop --cwc-infobar-font-color - font color used in custom scheme.
   * @prop --cwc-infobar-font-color-custom - font color used in custom scheme.
   */
  display: block;
  max-height: 600px;
  transition: max-height $infobar-animation-duration;

  background-color: #fff;
  color: #333;

  .wrapper {
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: space-between;
    max-width: $infobar-wrapper-maxwidth;

    margin: 0 auto;
    padding: $infobar-wrapper-padding-vert 1rem;

    .inner {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
    }

    close-btn {
      display: flex;
      flex: 0 0 auto;
      margin-left: 1rem;
      fill: currentColor;
      cursor: pointer;

      slot[name='close-icon'] > *,
      ::slotted(*) {
        width: 1.1rem;
      }
    }
  }
}

::slotted(*) {
  margin: 0;
  padding: 0;
  background-color: transparent;
  color: inherit;
}

/**
 * color schemes
 */
:host([color-scheme='blue']) {
  background-color: var(--cwc-infobar-background-color-blue, #2d7aab);
  color: var(--cwc-infobar-font-color, #fff);
}

:host([color-scheme='custom']) {
  background-color: var(--cwc-infobar-background-color-custom, $infobar-custom-background-color);
  color: var(--cwc-infobar-font-color-custom, $infobar-custom-font-color);
}

:host([color-scheme='green']) {
  background-color: var(--cwc-infobar-background-color-green, #314d30);
  color: var(--cwc-infobar-font-color, #fff);
}

:host([color-scheme='grey']) {
  background-color: var(--cwc-infobar-background-color-grey, #484848);
  color: var(--cwc-infobar-font-color, #fff);
}

:host([color-scheme='red']) {
  background-color: var(--cwc-infobar-background-color-red, #75070c);
  color: var(--cwc-infobar-font-color, #fff);
}

:host([color-scheme='violet']) {
  background-color: var(--cwc-infobar-background-color-violet, #9665ba);
  color: var(--cwc-infobar-font-color, #fff);
}
